import { InviteApiClientImpl } from './invite-api-client';

export const defaultInviteApiClient = new InviteApiClientImpl();
